import XHR from 'bpm-xhr';

import LocalStorageController from './local-storage';
import QueryController from './query';

class DataController {

	api(query, id, path) {
		return new Promise((resolve, reject) => {
			const expired = Date.now() - (1000 * 60 * 5); // 5 min
			const cached = LocalStorageController.get(id);

			if (cached && cached.timestamp > expired) {
				resolve(cached.response);
			} else {
				const data = new FormData();
				data.append('query', query);

				new XHR('json')
					.post('/php/api.php', data)
					.then((xhr) => {
						// console.log(xhr);
						if (xhr.response) {
							if (xhr.response.data) {
								let parsed = xhr.response.data;
								if (path) for (const p of path) parsed = parsed[p];
								LocalStorageController.set(id, {
									timestamp: Date.now(),
									response: parsed
								});
								// console.log(id, parsed);
								resolve(parsed);
							} else if (xhr.response.errors) {
								reject(new Error(xhr.response.errors[0].message));
							}
						} else {
							reject();
						}
					})
					.catch(reject);
			}
		});
	}

	loadTemplate(path) {
		return new Promise((resolve, reject) => {
			new XHR('text')
				.get(`/modules/${path}/template.html`)
				.then((xhr) => {
					xhr.response ? resolve(xhr.response) : reject(new Error(`Template [${path}] not found`));
				})
				.catch(reject);
		});
	}

	loadGlobals() {
		return this.api(QueryController.globals(), 'globals');
	}

	loadPage(type, slug) {
		return this.api(QueryController.page(type, slug), `page/${slug}`, ['entriesConnection', 'edges', 0]);
	}

}

export default new DataController();
